import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZMaster2A: IAbstractModule = {
  type: IModuleType.masterZ2,
  name: 'Z Master 2 A',
  hasScreen: true,
  columns: [
    [
      {
        name: "1",
        connector: "1",
        cell_size_id: 3,
        accessible: false,
      },
      {
        name: "2",
        connector: "2",
        cell_size_id: 2,
        accessible: true,
      },
    ],
  ]
};
